export default __webpack_public_path__ + "static/media/gas-pump.c260f670.svg";